import React, { useState, useCallback } from 'react';

import Dropdown, {
  MultiAutocompleteTokenControl,
  VirtualizedMenu,
} from '@adsk/alloy-react-dropdown';
import Portal from '@adsk/alloy-react-portal';

import { getFilteredItems, renderDropdownMenuItem } from '../helpers/utils';

const MultiSelectBox = ({
  items,
  selectedItems,
  placeholder: placeholderProp,
  setSelectedItems,
  renderFooter: renderFooterProp,
}) => {
  const shouldCustomizeMenuFooter =
    renderFooterProp || (selectedItems || []).length === 0;

  const [inputValue, setInputValue] = useState('');
  const [placeholder, setPlaceholder] = useState(placeholderProp);

  const onInputValueChange = useCallback(
    ({ inputValue }) => setInputValue(inputValue),
    [],
  );

  const onIsOpenChange = useCallback(
    ({ isOpen }) => {
      setPlaceholder(isOpen ? null : placeholderProp);
    },
    [placeholderProp],
  );

  const onSelectedItemsChange = useCallback(
    ({ selectedItems }) => {
      setSelectedItems(selectedItems);
    },
    [setSelectedItems],
  );

  const renderMenuItem = (itemProps) =>
    renderDropdownMenuItem(itemProps, inputValue);

  const renderFooter = () => (renderFooterProp ? renderFooterProp() : null);

  return (
    <Dropdown
      isAutocomplete
      isMultiple
      style={{ width: '100%' }}
      placeholder={placeholder}
      inputValue={inputValue}
      items={items}
      selectedItems={selectedItems}
      getFilteredItems={getFilteredItems}
      renderControl={(props) => <MultiAutocompleteTokenControl {...props} />}
      renderMenu={(menuProps, virtualProps) => (
        <Portal container={document.body}>
          {VirtualizedMenu.render(
            {
              ...menuProps,
              renderMenuItem,
              ...(shouldCustomizeMenuFooter && { renderFooter }),
            },
            virtualProps,
          )}
        </Portal>
      )}
      onInputValueChange={onInputValueChange}
      onIsOpenChange={onIsOpenChange}
      onSelectedItemsChange={onSelectedItemsChange}
    />
  );
};

export default MultiSelectBox;
